import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes, FaPhone, FaHome } from 'react-icons/fa';
import { servicesData } from '../data/servicesData';
import '../styles/ConsultationForm.css';

const ConsultationForm = ({ isOpen, onClose, type = 'consultation', initialService = '' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: initialService || (type === 'consultation' ? 'Consultation' : ''),
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prepare data for SheetDB
    const formDataForApi = {
      name: formData.name || '',
      email: formData.email || '',
      phone: formData.phone,
      service: formData.service,
      msg: formData.message || ''
    };

    try {
      const response = await fetch('https://sheetdb.io/api/v1/yeglfi70ssbxg', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: [formDataForApi]
        })
      });

      const result = await response.json();
      
      if (response.ok) {
        alert('Thank you! Your request has been submitted successfully.');
        onClose();
      } else {
        throw new Error(result.error || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your request. Please try again.');
    }
  };

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!isOpen || !mounted) return null;

  return createPortal((
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>
        
        <div className="form-header">
          <div className="form-icon">
            {type === 'consultation' ? <FaPhone /> : <FaHome />}
          </div>
          <h2>{type === 'consultation' ? 'Free Consultation' : 'Get a Free Quote'}</h2>
          <p>{type === 'consultation' 
            ? 'Fill out the form below and our expert will contact you shortly' 
            : 'Tell us about your project and get a free quote'}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name (Optional)"
              value={formData.name}
              onChange={handleChange}
              aria-label="Your Name"
            />
          </div>
          
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address (Optional)"
              value={formData.email}
              onChange={handleChange}
              aria-label="Email Address"
            />
          </div>
          
          <div className="form-group">
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number *"
              value={formData.phone}
              onChange={handleChange}
              required
              aria-label="Phone Number (Required)"
            />
          </div>

          {type === 'quote' && (
            <div className="form-group">
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                aria-label="Select a Service"
                className="service-select"
                disabled={type === 'consultation'}
              >
                {type === 'quote' ? (
                  <>
                    <option value="">Select a Service</option>
                    {servicesData.map(service => (
                      <option key={service.id} value={service.title}>
                        {service.title}
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="Consultation">General Consultation</option>
                )}
              </select>
            </div>
          )}

          <div className="form-group">
            <textarea
              name="message"
              placeholder={type === 'consultation' ? "What would you like to discuss? (Optional)" : "Tell us about your project (Optional)"}
              value={formData.message}
              onChange={handleChange}
              rows="4"
              aria-label="Your Message"
            ></textarea>
          </div>

          <button type="submit" className="submit-button">
            {type === 'consultation' ? 'Request Free Consultation' : 'Get Free Quote'}
          </button>
        </form>
      </div>
    </div>
  ), document.getElementById('modal-root'));
};

export default ConsultationForm;
